export const SW_VERSION = "v2";


export const isReallyOnline = async () => {
  try {
    const res = await fetch(
      "https://stocksense-backend-g1kp.onrender.com/health",
      {
        method: "HEAD",
        cache: "no-store",
        signal: AbortSignal.timeout(4000),
      }
    );
    return res.ok;
  } catch {
    return false;
  }
};

export const pingBackend = async () => {
  if (!navigator.onLine) return;
  try {
    await fetch("https://stocksense-backend-g1kp.onrender.com/", {
      method: "GET",
      signal: AbortSignal.timeout(5000),
    });
  } catch {
    // silent
  }
};